import {Totals, TotalsDataHook} from '../../../../../common/components/Totals/Totals';
import {Text} from 'wix-ui-tpa/cssVars';
import {getTotal} from '../../../../../domain/utils/total.util';
import React from 'react';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {classes} from '../TotalsSection.st.css';
import {TaxIncludedRow} from './TaxIncludedRow';
import {TotalUpdateSkeleton} from '../../TotalUpdateSkeleton';

export const TotalRow = () => {
  const {cartSummary, isCartSummaryUpdating} = useControllerProps().checkoutStore;
  const localeKeys = useLocaleKeys();

  return (
    <Totals.TotalsSection dataHook={TotalsSectionDataHooks.TotalSection}>
      <Totals.TotalsRow
        dataHook={TotalsSectionDataHooks.TotalRow}
        title={() => (
          <Text className={classes.totalRowText} data-hook={TotalsDataHook.TotalsRowTitle}>
            {localeKeys.checkout.order_summary.totals.total()}
          </Text>
        )}
        value={() =>
          isCartSummaryUpdating ? (
            <TotalUpdateSkeleton size="medium" />
          ) : (
            <Text data-hook={TotalsSectionDataHooks.TotalRowValue} className={classes.totalRowText}>
              {getTotal(cartSummary!)}
            </Text>
          )
        }
      />
      <TaxIncludedRow />
    </Totals.TotalsSection>
  );
};
